import { Box } from '@wix/design-system';
import { CoreDomainSearchStore, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { DomainIntentReferral } from '@wix/domains-serverless-interface';
import React, { useEffect } from 'react';
import { ResultsHeader } from '../../../Components/Headers/ResultsHeader/ResultsHeader';
import { Recommendations, RecommendationsError } from '../../../Components/Recommendations';
import { VoucherBanner } from '../../../Components/VoucherBanner';
import { useDomainSearchGateBi } from '../../../hooks/useDomainSearchGateBi';
import { useQueryParams } from '../../../hooks/useQueryParams';
import { useQuerySubmit } from '../../../hooks/useQuerySubmit';
import { DEFAULT_LIMIT, useRecommendations } from '../../../hooks/useRecommendations';
import { useResultsBack } from '../../../hooks/useResultsBack';
import { useResultsPageOfferingsBi } from '../../../hooks/useResultsPageOfferingsBi';
import { ViewMode } from '../../../types';
import s from '../../resultsPage.scss';
import transition from '../../viewTransitions.css';
import { useStatusSlot } from '../../ResultsLayout/StatusSlot';
export const FunnelResultsPage = _ref => {
  let handlers = _ref.handlers,
    externalViewer = _ref.externalViewer;
  const _useQueryParams = useQueryParams(),
    getQueryParam = _useQueryParams.getQueryParam;
  const autoInvokeOverride = getQueryParam('invoke') === 'true' ? true : undefined;
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      handlers,
      autoInvokeOverride,
      uiConfig: {
        fullPage: true,
        referralAdditionalInfo: DomainIntentReferral.CONNECT_FUNNEL,
        sameTab: true
      }
    }
  }, /*#__PURE__*/React.createElement(FunnelResultsPageContent, null));
};
export const FunnelResultsPageContent = () => {
  const handleBackClick = useResultsBack({
    toGate: true
  });
  useDomainSearchGateBi({
    viewMode: ViewMode.FUNNEL_RESULTS_PAGE
  });
  const _useRecommendations = useRecommendations({
      limit: DEFAULT_LIMIT,
      enableEarlyExactMatch: true
    }),
    recommendations = _useRecommendations.recommendations,
    isLoading = _useRecommendations.isLoading,
    isLeadingCardLoading = _useRecommendations.isLeadingCardLoading,
    query = _useRecommendations.query,
    hasMore = _useRecommendations.hasNextPage,
    fetchNextPage = _useRecommendations.fetchNextPage,
    isFetchingNextPage = _useRecommendations.isFetchingNextPage,
    error = _useRecommendations.error,
    biError = _useRecommendations.biError,
    biErrorSubtype = _useRecommendations.biErrorSubtype,
    onRetry = _useRecommendations.onRetry,
    isPricingLoading = _useRecommendations.isPricingLoading;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery(),
    updateUrl = _DomainSearchSuiteMod.updateUrl;
  useQuerySubmit({});
  useResultsPageOfferingsBi({
    recommendations,
    isLoading,
    biError,
    biErrorSubtype
  });
  useEffect(() => {
    return () => {
      CoreDomainSearchStore.resetStore();
    };
  }, []);
  const emptyQueryStatus = !isLoading && recommendations.length > 0 && !query;
  const StatusComponent = useStatusSlot(emptyQueryStatus);
  const searchBar = /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    compact: true,
    showOptionsIfEmptyInput: false,
    autoFocus: false,
    useModalToolbar: false,
    onSubmit: filters => {
      updateUrl(filters);
    },
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    Layouts: {
      StatusComponent
    }
  });
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    display: "grid",
    className: `${s.resultsPage} ${s.noInsights}`,
    gap: "SP6 0",
    height: "100%",
    backgroundColor: "white",
    overflow: "auto"
  }, /*#__PURE__*/React.createElement(Box, {
    boxSizing: "border-box",
    align: "center",
    gridArea: "header",
    top: "0",
    position: "sticky",
    width: "100%",
    zIndex: 10,
    padding: "SP5 48px",
    backgroundColor: "white",
    direction: "vertical",
    gap: "SP6"
  }, /*#__PURE__*/React.createElement(VoucherBanner, null), /*#__PURE__*/React.createElement(ResultsHeader, {
    className: transition.header,
    onBackClick: handleBackClick
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      zIndex: 11
    },
    className: transition.searchBar
  }, searchBar)), error ? /*#__PURE__*/React.createElement(RecommendationsError, {
    error: error,
    onRetry: onRetry,
    gridColumn: "1 / -1"
  }) : /*#__PURE__*/React.createElement(Recommendations, {
    recommendations: recommendations,
    isLoading: isLoading,
    isLeadingCardLoading: isLeadingCardLoading,
    hasMore: hasMore,
    isPricingLoading: isPricingLoading,
    fetchNextPage: () => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'show_more_results'
      });
      fetchNextPage();
    },
    isFetchingNextPage: isFetchingNextPage,
    gridArea: "content",
    className: s.centeredContent
  }));
};
//# sourceMappingURL=FunnelResultsPage.js.map